import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import axios from 'axios';
import { getSiteKey } from '../../components/RecaptchaProvider/RecaptchaProvider.utils';
import { getBusinessTypePath } from '../../utils/api';
import { isValidEmail } from '../../utils/strings';
export function createContact(_x, _x2, _x3, _x4) {
  return _createContact.apply(this, arguments);
}
function _createContact() {
  _createContact = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(businessId, businessType, locationId, recaptchaToken) {
    var formData,
      headers,
      url,
      fullUrl,
      payload,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          formData = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
          headers = {};
          url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
          fullUrl = "".concat(url, "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/locations/").concat(locationId, "/contacts/create/");
          payload = _objectSpread(_objectSpread({}, formData), {}, {
            'recaptcha-token': recaptchaToken,
            'recaptcha-site-key': getSiteKey()
          });
          return _context.abrupt("return", axios.post(fullUrl, payload, {
            headers: headers
          }));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createContact.apply(this, arguments);
}
export function getErrors() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var formData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var errors = {};
  fields.forEach(function (field) {
    var key = field.key;
    var value = formData[key];
    if (!value) {
      errors[key] = 'Please enter a valid value';
    }
    if (key === 'email' && !isValidEmail(value)) {
      errors[key] = 'Please enter a valid email';
    }
  });
  return errors;
}